import { User } from "Adapter/IAdapter";
import { atom } from "recoil";

export const CurrentUser = atom<User|undefined>({
  key: "user",
  default: undefined,
  dangerouslyAllowMutability: true,
});
